import {cn} from 'platform/shared-tw';

import {
  createKeyDownHandler,
  partFill,
  partStroke,
  type DiagramVariant,
} from '../shared/partVariants';

interface EngineCoolantProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function EngineCoolant(props: EngineCoolantProps) {
  return (
    <svg
      width="58"
      height="38"
      viewBox="0 0 58 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute focus:outline-none focus-visible:outline-none [pointer-events:none] cursor-pointer group"
      style={{top: 116, left: 203}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
    >
      <path
        d="M1 5.99997C1 5.99997 1 1 6 0.999969L52 0.999971C57 1 57 5.99997 57 5.99997V32C57 32 57 37 52 37L6 37C1 37 1 32 1 32L1 5.99997Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M1 5.99997C1 5.99997 1 1 6 0.999969L52 0.999971C57 1 57 5.99997 57 5.99997V32C57 32 57 37 52 37L6 37C1 37 1 32 1 32L1 5.99997Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M21 15L18 20.1961L12 20.1961L8.99997 15L12 9.80383L18 9.80383L21 15Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
